import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

// import Coupon from './templates/Coupon';
import { proxy } from 'services/shared';

import * as templates from './templates';

const DefaultComponent = () => <div>Document</div>;

export const print = async ({
  title = 'Print Document',
  html = 'Document',
  fullHtml = '',
  url = '',
} = {}) => {
  const height = window.innerHeight;
  const width = window.innerWidth;
  try {
    if (url && !url.includes('undefined')) {
      // eslint-disable-next-line no-param-reassign
      fullHtml = await window.fetch(proxy + url).then(res => res.text());
    }
    const mywindow = window.open(
      '',
      'PRINT',
      `width=${width}, height=${height}`,
    );

    mywindow.document.write(
      (
        fullHtml ||
        `<html><head><title>${title}</title>
    </head><body >${html}</body></html>`
      ).concat(
        `<script>
      var filtered = Array.prototype.map.call(
        window.document.querySelectorAll('img'), 
        function (item) {
          if (item.src === '') return Promise.resolve();
          var img = new Image();
          img.src = item.src;
          return new Promise(resolve => {
            img.addEventListener('load', resolve)
            img.addEventListener('error', resolve)
            if (img.complete) resolve()
          })
        }
      );
      Promise.all(filtered)
        .then(() => new Promise(res => setTimeout(res, 300)))
        .then(() => {
          window.document.close();
          window.focus();
          window.print();
          window.close();
        })
      </script>`,
      ),
    );
  } catch (err) {
    console.error(
      'Failed to print receipt',
      { html, fullHtml, url, title },
      err,
    );
    return false;
  }
  return true;
};

export const printFromTemplate = async ({
  Template = DefaultComponent,
  title = 'Print Document',
}) => {
  const html = renderToStaticMarkup(Template);

  print({
    html,
    title,
  });
};

export default ({
  url,
  html = renderToStaticMarkup(<DefaultComponent />),
  title = 'Print Document',
  children,
}) => {
  return <span onClick={() => print({ url, title, html })}>{children}</span>;
};
